<template>
  <div>
    <div class="header-sticky">
      <!-- <resend-bar /> -->
      <Header />
    </div>

    <router-view />
    <!-- <div clas="footer">
      <Footer />
    </div> -->
  </div>
</template>

<script>
import Header from "../App/HeaderGeneric.vue";
import Footer from "../App/FooterGeneric.vue";
import ResendBar from "../App/resendBar.vue";
export default {
  name: "SignupLayout",
  components: {
    Header,
    Footer,
    ResendBar
  }
};
</script>

<style lang="scss" scoped>

  .footer{
    position: absolute;
    top:1239px;
  }
.header-sticky {
  position: sticky;
  top: 0;
  z-index: 100;
}
</style>



// WEBPACK FOOTER //
// src/components/Signup/SignupLayout.vue